import {
  message,
  Space,
  Select,
  Popconfirm,
  Input,
  Row,
  Col,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  MensajeError,
    ModalItem,
    ButtonItem,
    Form,
    FormItem,
    SelectItem,
    SwitchItem,
    InputItem
} from "../../../../../Components/Items";
import facturaPdf from "../../../../../Pdf/facturaPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreo from "../../../Ventas/MandarCorreo/MandarCorreo";
import { EditOutlined } from "@ant-design/icons";
import EditarClienteModal from "./EditarClienteModal/EditarClienteModal";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select

class ModalGenerarFacturaVariasRemisiones extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        pdf: null,
        todasBancos: null,
        todasFormasDePago: null,
        objetoBancos: null,
        objetoFormasDePago: null,
        contado: 1,
        factura: 2,
        modalCorreo: false,
        modalCorreoId: null,
        todasDoctores: [],
        todasPacientes: [],
        objetoDoctores: null,
        objetoPacientes: null,
        cliente: null,
        modalEditarCliente: false,
        objetoRegimenFiscal: null,
        todasRegimenFiscal: null,
        activarRegimenes: false,
        clienteId: null,
        todasSeriesVenta: [],
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }

    consultarSeriesVenta() {
        axios
            .post(
                "serieventas/selectSeriesVentaActivas",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                const series = Array.isArray(res.data) ? res.data : [];
                this.setState({ todasSeriesVenta: series });
            });
    }

    async consultarTodo() {
        this.setState({ loading: true });
        if (
            this.props.complementoSeriesPersonalizadas &&
            this.props.permisoElegirSerieFolioPersonalizado
        ) {
            this.consultarSeriesVenta();
        }
        await axios
            .post(
                "ventas/datosFacturaVariasRemisiones",
                { ventasIds: this.props.ventasIds, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasFormasDePago: res.data.formasDePago,
                        todasProyectos: res.data.proyectos,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        cliente: res.data.cliente,
                        activarRegimenes: res.data.activarRegimenes,
                        todasRegimenFiscal: res.data.regimenesFiscales,
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),

                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),

                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.c_RegimenFiscal + " - " + value.descripcion}
                                </Option>
                            );
                        }),
                        contado: res.data.contado,
                        clienteId: res.data.clienteId,
                    })

                    if (res.data.contado !== 1) {
                        this.formRef.current.setFieldsValue({
                            formaDePagoId: '6125149afe07662acc100d6d'
                        })
                    } else {
                        this.formRef.current.setFieldsValue({
                            formaDePagoId: '6125149afe07662acc100d58'
                        })
                    }

                    this.formRef.current.setFieldsValue({
                        usoDeCfdiId: res.data.usoDeCfdiId,
                        doctorId: res.data.doctorId,
                        pacienteId: res.data.pacienteId,
                        cirugiaId: res.data.cirugiaId,
                        contado: res.data.contado,
                        proyectoId: res.data.proyectoId,
                        cuentasXC: res.data.cuentasXC,
                    })

                    if (res.data.activarRegimenes) {
                        this.formRef.current.setFieldsValue({ regimenFiscalId: res.data.regimenDefaultId })
                    }

                } else {
                    message.warning('No se cargaron bien los datos')
                }
            });
        if (this.props.equipoMedico) {

            await axios
                .post(
                    "ventas/selectDatosParaEquipoMedico",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            todasDoctores: res.data.doctores,
                            todasPacientes: res.data.pacientes,
                            todasCirugias: res.data.cirugias,
                            objetoDoctores: res.data.doctores.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoPacientes: res.data.pacientes.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoCirugias: res.data.cirugias.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                        });
                    } else {
                        message.error('No se encontraron datos de equipo medico')
                    }
                });

        }
        this.setState({ loading: false });
    }

    onFinishFailed(e) {
        message.error("Revisa que los datos sean correctos");
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "ventas/agregarFacturaVariasRemisiones",
                {
                    ...values,
                    ventasIds: this.props.ventasIds,
                    empresaId: this.props.empresaId,
                    clienteId: this.state.clienteId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una factura");
                    if (res.data.avisoPolizas) message.warning(res.data.avisoPolizas, 8);
                    if (res.data.respuestaFactura.status === "success") {
                        if (window.registrarMovimiento) {
                            const dataSat = res.data.respuestaFactura.dataSat;
                            const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

                            window.registrarMovimiento({
                                titulo: 'Factura Emitida',
                                mensaje: `${nombreArchivo} - Haga click para descargar`,
                                icono: 2,
                                onClick: () => {
                                    var xmltext = res.data.respuestaFactura.data.cfdi;

                                    var filename = nombreArchivo + ".xml";
                                    var pom = document.createElement("a");
                                    var bb = new Blob([xmltext], { type: "text/plain" });

                                    pom.setAttribute("href", window.URL.createObjectURL(bb));
                                    pom.setAttribute("download", filename);

                                    pom.dataset.downloadurl = [
                                        "text/plain",
                                        pom.download,
                                        pom.href,
                                    ].join(":");
                                    pom.draggable = true;
                                    pom.classList.add("dragout");

                                    pom.click();

                                    const pdf = facturaPdf(res.data);

                                    pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                                },
                            });
                        }

                        this.setState({
                            modalCorreo: true,
                            modalCorreoId: res.data.ventaId,
                        });
                    }
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar la factura",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y la factura no se registro");
                }
            });
    }

    cerrarGenerarFacturaVariasRemisiones() {
        this.props.cerrarGenerarFacturaVariasRemisiones();
    }

    onChangeContado(value) {
        if (value !== 1) {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d6d'
            })
        } else {
            this.formRef.current.setFieldsValue({
                formaDePagoId: '6125149afe07662acc100d58'
            })
        }
    }

    cerrarMandarCorreo() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current.resetFields();
        this.props.onFacturaGenerada();
    }

    abrirModalEditarCliente() {
        this.setState({ modalEditarCliente: true });
    }

    // Función para cerrar el modal de editar cliente
    cerrarModalEditarCliente() {
        this.setState({ modalEditarCliente: false });
    }

    // Función para obtener el nombre completo del cliente
    obtenerNombreCliente() {
        const cliente = this.state.cliente;

        // Si es persona física, mostrar nombre completo
        if (cliente && cliente.persona === false) {
            return `${cliente.nombre} ${cliente.apellidoPaterno || ''} ${cliente.apellidoMaterno || ''}`.trim();
        } else if (cliente && cliente.persona === true) {
            // Si es empresa, mostrar razón social o nombre comercial
            return cliente.razonSocial || cliente.nombreComercial || cliente.nombre;
        }
    }

    render() {
        return (
            <>
                <ModalItem
                    title="Generar Factura Varias Remisiones"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarGenerarFacturaVariasRemisiones.bind(this)}
                    paddingTop
                    zIndex={this.props.zIndex}
                >
                    <Form
                        ref={this.formRef}
                        name="generarFacturaVariasRemisiones"
                        layout
                        width={700}
                        onCancel={this.cerrarGenerarFacturaVariasRemisiones.bind(this)}
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            label='Cliente'
                            name="cliente"
                            margin
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <Input.Group compact>
                                <InputItem
                                    value={this.obtenerNombreCliente()}
                                    disabled
                                    placeholder="Cliente"
                                    style={{ width: 'calc(100% - 40px)' }}
                                />
                                <ButtonItem
                                    icon={<EditOutlined />}
                                    onClick={this.abrirModalEditarCliente.bind(this)}
                                    type="primary"
                                    style={{ width: '40px' }}
                                    title="Editar cliente"
                                />
                            </Input.Group>
                        </FormItem>
                        {this.state.activarRegimenes && (
                            <FormItem
                                label="Regimen Fiscal"
                                name="regimenFiscalId"
                                margin
                                required
                            >
                                <SelectItem placeholder="Regimen Fiscal">
                                    {this.state.objetoRegimenFiscal}
                                </SelectItem>
                            </FormItem>
                        )}
                        {this.props.complementoSeriesPersonalizadas && this.props.permisoElegirSerieFolioPersonalizado && this.state.todasSeriesVenta.length > 0 && (
                            <FormItem
                                label="Serie"
                                name="serieVentaId"
                                margin
                            >
                                <SelectItem placeholder="Selecciona una serie (opcional)" allowClear>
                                    {this.state.todasSeriesVenta.map((serie) => (
                                        <Option value={serie._id} key={serie._id}>
                                            {`${serie.nombre} (${serie.serieFacturas}/${serie.serieRemisiones}) - Sig. Factura: ${serie.folioFacturas ?? 1}`}
                                        </Option>
                                    ))}
                                </SelectItem>
                            </FormItem>
                        )}
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.contado !== curr.contado}>
                            {({ getFieldValue }) => {
                                const contado = getFieldValue('contado')
                                return (
                                    <FormItem
                                        name="formaDePagoId"
                                        label="Forma Pago"
                                        initialValue="6125149afe07662acc100d58"
                                        margin
                                        required
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                    >
                                        <SelectItem disabled={contado !== 1} placeholder="Forma de Pago">
                                            {this.state.objetoFormasDePago}
                                        </SelectItem>
                                    </FormItem>
                                )
                            }}
                        </FormItem>
                        <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                                const contado = getFieldValue("contado");
                                if (contado === 1 || contado === 3) {
                                    return (
                                        <>
                                            <FormItem
                                                label="Cuentas XC"
                                                name="cuentasXC"
                                                margin
                                                initialValue={false}
                                                valuePropName="checked"
                                            >
                                                <SwitchItem disabled />
                                            </FormItem>
                                        </>
                                    );
                                }
                            }}
                        </FormItem>
                        <FormItem
                            name="usoDeCfdiId"
                            label="Uso de CFDI"
                            margin
                            required
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <SelectItem placeholder="Uso de CFDI">
                                {this.state.objetoUsosDeCFDI}
                            </SelectItem>
                        </FormItem>

                        <FormItem
                            label="Proyecto"
                            name="proyectoId"
                            margin
                            required
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                        >
                            <SelectItem
                                placeholder="Proyecto"
                                disabled
                            >
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </FormItem>
                        {this.props.equipoMedico && (
                            <>
                                <FormItem
                                    label="Doctor"
                                    name="doctorId"
                                    margin
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                >
                                    <SelectItem placeholder="Doctor">
                                        {this.state.objetoDoctores}
                                    </SelectItem>
                                </FormItem>
                                <FormItem label="Paciente" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                    <Row>
                                        <Col span={12}>
                                            <FormItem
                                                name="pacienteId"
                                                margin
                                                noStyle
                                            >
                                                <SelectItem placeholder="Paciente">
                                                    {this.state.objetoPacientes}
                                                </SelectItem>
                                            </FormItem>
                                        </Col>
                                        <Col span={12}>
                                            <FormItem
                                                name="cirugiaId"
                                                margin
                                            >
                                                <SelectItem placeholder="Cirugia">
                                                    {this.state.objetoCirugias}
                                                </SelectItem>
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </FormItem>
                            </>

                        )}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "right",
                                marginTop: 20,
                                marginBottom: 10,
                            }}
                        >
                            <Space>

                                <Popconfirm
                                    title="¿Generar factura?"
                                    onConfirm={() => this.formRef.current.formRef.current.submit()}
                                    okText="Ok"
                                    cancelText="Cancelar"
                                >
                                    <ButtonItem
                                        type="primary"
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Generar Factura
                                    </ButtonItem>
                                </Popconfirm>
                                <ButtonItem
                                    type="primary"
                                    danger
                                    onClick={this.cerrarGenerarFacturaVariasRemisiones.bind(this)}
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Regresar
                                </ButtonItem>
                            </Space>
                        </div>
                    </Form>
                </ModalItem>
                <MandarCorreo
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreo={this.cerrarMandarCorreo.bind(this)}
                    zIndex={this.props.zIndex + 1}
                />
                <EditarClienteModal
                    visible={this.state.modalEditarCliente}
                    cliente={this.state.cliente}
                    onCancel={this.cerrarModalEditarCliente.bind(this)}
                    onClienteActualizado={(clienteActualizado) => {
                        this.setState({ cliente: clienteActualizado });
                        this.cerrarModalEditarCliente();
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        certificada: state.empresa.certificada,
        complementoDetallista: state.empresa.complementoDetallista,
        complementoSeriesPersonalizadas: state.empresa.complementoSeriesPersonalizadas,
        equipoMedico: state.empresa.equipoMedico,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
        permisoElegirSerieFolioPersonalizado:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6a9b6273e58adfd453dfa6f7"
            )?.activado,
    };
};

export default connect(mapStateToProps)(ModalGenerarFacturaVariasRemisiones);
